import gqls from "@/graphql/bonus.gql";
import { httpServer as http } from "@/lib/axios";
import { httpServer as downFilehttp } from "@/lib/downFileAxios";

// callback 调用
import { resRest, easyMutate } from "@root/lib/utils";

import BbqActions from "@root/lib/bbqActions";
const shortAction = new BbqActions(gqls, []);
const gqlActions = shortAction.getValues();

const bonus = {
  namespaced: true,
  state: {
    REWAED_TYPE_OPTIONS: [
      {
        value: "",
        label: "全部"
      },
      {
        value: "1",
        label: "可使用"
      },
      {
        value: "2",
        label: "待审核"
      },
      {
        value: "3",
        label: "兑现记录"
      }
    ]
  },
  getters: {},
  actions: {
    ...gqlActions,
    // 奖励金明细列表
    async myBonusPaging({ rootState }, params = {}) {
      const data = await http(
        "/k1/rewardTradeBill/myBonusPaging",
        params
      );
      return data ? data.data : { list: [], total: 0 };
    },
    // 顶部总计
    async myBonusSum({ rootState }, params = {}) {
      const data = await http(
        "/k1/rewardTradeBill/myBonus",
        params
      );
      return data ? data.data : {};
    },
    // 导出
    async myBonusExport({ rootState }, params = {}) {
      const data: any = await downFilehttp({
        url: "/k1/rewardTradeBill/myBonusExport",
        params
      });

      return data;
    },
    async newWithdraw({ rootState }, params = {}) {
      const data: any = await http(
        "/k1/wallet/withdraw",
        params
      );

      return data ? data.data : {};
    },
    // 
  },
  mutations: {
    easyMutate
  }
};
export default bonus;
